import { render, staticRenderFns } from "./PressareaExhibition.vue?vue&type=template&id=4793faa2&"
import script from "./PressareaExhibition.vue?vue&type=script&lang=js&"
export * from "./PressareaExhibition.vue?vue&type=script&lang=js&"
import style0 from "./PressareaExhibition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports